<template>
	<span :class="['dc-spinner', colorClass, sizeClass]" v-text="txtLoading"></span>
</template>

<script>
export default {
	props: ['color', 'size'],
	computed: {
		colorClass() {
			return (this.color) ? 'dc-spinner--' + this.color : ''
		},
		sizeClass() {
			return (this.size) ? 'dc-spinner--' + this.size : ''
		},
		txtLoading() {
			return this.$t('loading') || ''
		}
	}
}
</script>

<style lang="scss">
	@import "~@/styles/scss/global/layout/spinner";
</style>
